import React from "react";
import ReactApexChart from "react-apexcharts";

export const MyPage = () => {
  // Data untuk pie chart
  const data = {
    section_title: "Pengalaman",
    question_desc: "Apakah Anda pernah membeli produk Kuppila?",
    question_type: "RADIO_BUTTON",
    question_no: 1,
    question_answer_total: "10",
    question_answer: ["7", "3"],
    question_option: ["Pernah", "Tidak"],
  };

  const options = {
    chart: {
      type: "pie",
    },
    labels: data.question_option,
    title: {
      text: data.section_title,
      align: "center",
    },
    legend: {
      position: "bottom",
    },
  };

  const series = data.question_answer.map((value) => parseInt(value, 10));

  return (
    <div>
      <h2>{data.question_desc}</h2>
      <ReactApexChart options={options} series={series} type="pie" width="400" />
    </div>
  );
};

